// utils/getProjectImage.js

export default function getProjectImage(url) {
    const domain = new URL(url).hostname
        .replace("www.", "");

    return `/screenshots/${domain}.jpg`;
}